export default "__VITE_ASSET__CKUhKjD4__"